import { gql } from "@apollo/client";

export const GET_ASSET = gql`
    fragment InsightsPropertyTree on InsightsPropertyTree {
        id
        area
        fullAddress
        objectType
        propertyType
        crremPropertyType
        constructionYear
        nationalPropertyType
        latitude
        longitude
    }

    query GetLegacyNextAsset($id: ID!) {
        getLegacyNextAsset(id: $id) {
            id
            area
            name
            externalId
            properties {
                ...InsightsPropertyTree
                children {
                    ...InsightsPropertyTree
                    children {
                        ...InsightsPropertyTree
                        children {
                            ...InsightsPropertyTree
                            children {
                                ...InsightsPropertyTree
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_ASSET_INTENSITY = gql`
    query GetAssetIntensity($assetId: ID!, $from: DateTime!, $to: DateTime!) {
        getIntensity(assetId: $assetId, from: $from, to: $to) {
            to
            from
            value
            unit
            area
            breakdown {
                factors {
                    unit
                    to
                    supplierName
                    source
                    note
                    id
                    from
                    factor
                }
                consumption {
                    value
                    unit
                    type
                }
            }
        }
    }
`;
